module.exports = "/images/vendor/vue-paycard/src/3.jpg?fbdc2bb25693cb0fdda84491c5ebbfee";